/* eslint-disable import/prefer-default-export */ import { formatInTimeZone } from "date-fns-tz";
import format from "date-fns/format";
import frLocale from "date-fns/locale/fr";
import esLocale from "date-fns/locale/es";
import itLocale from "date-fns/locale/it";
import enUsLocale from "date-fns/locale/en-US";
import { isBefore } from "date-fns";
import isAfter from "date-fns/isAfter";
import parse from "date-fns/parse";
import addDays from "date-fns/addDays";
import subDays from "date-fns/subDays";
export var DATE_FNS_LOCALE_MAP = {
    "fr-FR": frLocale,
    "es-ES": esLocale,
    "it-IT": itLocale,
    "en-US": enUsLocale
};
var MERIDIAN_DATE_FORMAT = "yyyy-MM-dd";
export var formatDate = function(dateObj, dateFormat, locale) {
    return format(dateObj, dateFormat, locale && DATE_FNS_LOCALE_MAP[locale] ? {
        locale: DATE_FNS_LOCALE_MAP[locale]
    } : {});
};
export var formatDateInTimezone = function(dateObj, dateFormat, locale) {
    if (!dateObj) {
        return null;
    }
    var formattedDate = formatInTimeZone(dateObj, Intl.DateTimeFormat().resolvedOptions().timeZone, dateFormat, locale && DATE_FNS_LOCALE_MAP[locale] ? {
        locale: DATE_FNS_LOCALE_MAP[locale]
    } : {});
    return formattedDate;
};
export var getTimeZone = function() {
    return new Date().toLocaleTimeString("en-us", {
        timeZoneName: "short"
    }).split(" ")[2];
};
export var isBlockedDateInCalendar = function(date, startDate, maxFutureAllowedDays, maxPastAllowedDays) {
    var parsedStartDate = parse(startDate, MERIDIAN_DATE_FORMAT, new Date());
    var parsedEndDate = parse(date, MERIDIAN_DATE_FORMAT, new Date());
    var nextMaximumFutureAllowedDate = addDays(parsedStartDate, maxFutureAllowedDays);
    var nextMaximumPastAllowedDate = subDays(parsedStartDate, maxPastAllowedDays);
    return isAfter(parsedEndDate, nextMaximumFutureAllowedDate) || isBefore(parsedEndDate, nextMaximumPastAllowedDate);
};

//# sourceMappingURL=dateUtils.js.map